import script from "./DogPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DogPage.vue?vue&type=script&setup=true&lang=js"

import "./DogPage.vue?vue&type=style&index=0&id=09154666&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09154666"]])

export default __exports__